import { Button, Flex } from "antd";

import { DETECTED_CODE_TYPE_CLASS_MAP, FIELD_KEYS } from "constants/UnitFields";

const UnitMapCell = ({ data = {}, onClick }) => {
  return (
    <>
      <Flex vertical={true} className="map-cell">
        <Flex justify="center">
          <span className="x">{data[FIELD_KEYS.X] ?? "-"}</span>
        </Flex>
        <Button
          onClick={onClick}
          type="text"
          className={
            DETECTED_CODE_TYPE_CLASS_MAP[
              data[FIELD_KEYS.DETECTED_CODE]?.type
            ] ?? "gray"
          }
          style={{ borderRadius: 0 }}
        >
          {data[FIELD_KEYS.DETECTED_CODE]?.value ?? "-"}
        </Button>
      </Flex>
    </>
  );
};

export default UnitMapCell;
